export default {
	"subscribe.AccordingTo": "( 按",
	"subscribe.deduction": "扣费第",
	"subscribe.Expect": "期 )",
	"subscribe.PaymentTime": "支付时间：",
	"subscribe.OrderNumber": "订单编号：",
	"subscribe.UnfortunatelyNoMatchingDataWasFound": "非常遗憾，没有找到符合条件的数据",
	"subscribe.loadMore": "加载更多"
}